<template>
  <div id="app">
    <v-card-title class="bg-success-table-4 pt-16 pb-8 shadow-bottom">
      <h1 class="text-white-md">
        Master Pajak
      </h1>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-card class="mx-5 mt-6">
      <v-data-table
        :headers="headers"
        :items="resultMasterTax"
        :search="search"
        :loading="loading"
        loading-text="Loading... Please wait"
      >
        <!-- <template v-slot:item.action="{ item }"> -->
          <!-- <v-btn class="ma-1" fab dark x-small color="#236f71">
            <v-icon dark>mdi-file-account</v-icon>
          </v-btn> -->

          <!-- <v-btn
            class="ma-1"
            @click="goToEdit(item.id)"
            fab
            dark
            x-small
            color="#235c92"
          >
            <v-icon dark>mdi-pencil</v-icon>
          </v-btn> -->

          <!-- <v-btn
            class="ma-1"
            fab
            dark
            x-small
            @click="showModalDelete(item.id)"
            color="#e21717"
          >
            <v-icon dark>mdi-delete</v-icon>
          </v-btn> -->
        <!-- </template> -->
      </v-data-table>
      <!-- <v-fab-transition fluid style="z-index: 100">
        <v-btn fab fixed small color="#008ef8" @click="gotoAdd()" bottom right>
          <span class="text-white-sm">
            <v-icon>mdi-plus</v-icon>
          </span>
        </v-btn>
      </v-fab-transition> -->
    </v-card>
    <!-- modal Delete -->
    <v-dialog v-model="deleteDialog" persistent max-width="450">
      <v-card class="pa-2">
        <v-card-title class="text-blood pl-2 pt-1 pr-0 pb-3"
          >Delete Pajak
          <v-spacer></v-spacer>
          <v-icon
            class="float-right"
            color="grey"
            @click.prevent="deleteDialog = false"
            >mdi-close</v-icon
          >
        </v-card-title>
        <div class="text-center pa-3">
          <v-avatar size="142px" class="mb-4">
            <img src="@/assets/img/delete.png" />
          </v-avatar>
          <p class="text-blood">You Want To Delete This Pajak?</p>
        </div>
        <v-card-actions class="py-0 px-10">
          <v-spacer></v-spacer>
          <v-btn
            width="100%"
            rounded
            color="#F5F5F5"
            @click="deleteDialog = false"
            block
            dark
          >
            <span class="text-capitalize text-blue">Close</span>
          </v-btn>
        </v-card-actions>
        <v-card-actions class="py-0 px-10 mt-3 justify-center text-center">
          <v-btn
            :loading="loadingDel"
            @click="submitDelete"
            text
            block
            color="#F32626"
            >Yes! Delete this Pajak</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- dialog success -->
    <v-dialog v-model="dialog" persistent max-width="350">
      <v-card class="pa-8 pb-10 d-flex flex-column justify-center">
        <v-icon color="green" size="100px">mdi-checkbox-marked-circle</v-icon>
        <v-card-title class="title-card mx-auto text-center"
          >Delete Pajak <br />Success</v-card-title
        >
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            @click.prevent="closeSuccessNavigate"
            color="green"
            class="mt-3 w-full"
            width="100%"
            dark
          >
            <span class="text-capitalize">Okay</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- dialog failed -->
    <v-dialog v-model="dialog2" persistent max-width="350">
      <v-card class="pa-8 pb-10 d-flex flex-column justify-center">
        <v-icon color="#F32626" size="100px">mdi-alert-circle-outline</v-icon>
        <v-card-title class="title-card mx-auto text-center"
          >Delete Pajak <br />Failed</v-card-title
        >
        <p class="mx-auto">{{ errorMessage }}</p>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            @click.prevent="dialog2 = false"
            color="green"
            class="mt-3 w-full"
            width="100%"
            dark
          >
            <span class="text-capitalize">Okay</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const karyawan = createNamespacedHelpers("masterKaryawan");
export default {
  mounted() {
    this.$store.dispatch("masterKaryawan/getMasterTax");
  },
  computed: {
    ...karyawan.mapState(["resultMasterTax"])
  },
  data() {
    return {
      search: "",
      loading: false,
      deleteDialog: false,
      loadingDel: false,
      dialog: false,
      dialog2: false,
      errorMessage: null,
      headers: [
        { text: "Code", value: "code" },
        { text: "Name", value: "description" },
        { text: "Gender", value: "gender" },
        { text: "", value: "action" }
      ]
    };
  },

  methods: {
    gotoAdd() {
      setTimeout(() => {
        this.$router.push("/master-tax/add/");
      }, 1000);
    },
    goToEdit(val) {
      setTimeout(() => {
        this.$router.push("/master-tax/edit/" + val);
      }, 1000);
    },
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    showModalDelete(val) {
      this.deleteDialog = true;
      this.$store.commit("masterKaryawan/SET_IDTAX", val);
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    closeSuccessNavigate() {
      this.dialog = false;
      setTimeout(() => {
        this.$router.go();
      }, 200);
    },
    submitDelete() {
      // button effect
      this.loadingDel = true;
      this.$store
        .dispatch("masterKaryawan/deleteTax")
        .then(response => {
          const res = response.data;
          if (res.status) {
            this.deleteDialog = false;
            this.dialog = true;
            this.loadingDel = false;
          } else {
            this.deleteDialog = false;
            this.dialog2 = true;
            this.loadingDel = false;
          }
        })
        .catch(error => {
          const message = error.response.data.message;
          this.errorMessage = message;
          this.deleteDialog = false;
          this.dialog2 = true;
          this.loadingDel = false;
        });
    }
  }
};
</script>
